import * as actions from "actions/login";

export default (state = false, { type }) => {
  switch (type) {
    case actions.LOGIN:
      return true;
    case actions.AUTHENTICATE_SUCCESS:
    case actions.AUTHENTICATE_FAILED:
    case actions.LOGIN_FAILED:
    case actions.LOGIN_SUCCESS:
      return false;
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/login/isAuthenticating.js